import {observable, action, makeObservable} from "mobx";

class AdminStore {
    sites = undefined;
    submissions = undefined;
    users = undefined;
    projects = undefined;
    project = {};
    emails = undefined;
    email = {};
    teamMembers = undefined;
    summaries_by_site = {};
    summaries_by_id = {};
    clockify_timer = undefined;

    constructor() {
        makeObservable(this, {
            sites: observable,
            submissions: observable,
            users: observable,
            projects: observable,
            project: observable,
            emails: observable,
            email: observable,
            teamMembers: observable,
            summaries_by_site: observable,
            summaries_by_id: observable,
            clockify_timer: observable,

            setSites: action,
            setSubmissions: action,
            setUsers: action,
            setProjects: action,
            setProject: action,
            setEmails: action,
            setEmail: action,
            setTeamMembers: action,
            setSummariesBySiteId: action,
            setSummaryById: action,
            setClockifyTimer: action,
        })
    }

    initialize() {
        this.sites = undefined;
        this.project = {};
    }

    setSites(sites) {
        this.sites = sites;
    }

    setUsers(users) {
        this.users = users;
    }

    setSubmissions(submissions) {
        this.submissions = submissions;
    }

    setProjects(projects) {
        this.projects = projects;
    }

    setProject(project) {
        this.project[project.job_id] = project;
    }

    setEmails(emails) {
        this.emails = emails;
    }

    setEmail(email) {
        this.email[email.email_id] = email;
    }

    setTeamMembers(members) {
        this.teamMembers = members;
    }

    setSummariesBySiteId(summaries, siteId) {
        this.summaries_by_site[siteId] = summaries;
    }

    setSummaryById(summary) {
        this.summaries_by_id[summary.summary_id] = summary;
    }

    setClockifyTimer(timer) {
        this.clockify_timer = timer;
    }
};


export default new AdminStore();
